// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__15OpG","legacyBtn":"MutateMid_legacyBtn__18t0T"};